import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const testimonialData = [
  {
    image: '/assets/images/resource/testimonial-4.jpg',
    name: 'Aleesha Brown',
    role: 'Customers',
    text: 'To review means to look back over something for evaluation or memory. It’s always a joy to hear that the work I do has positively impacted our clients.'
  },
  {
    image: '/assets/images/resource/testimonial-5.jpg',
    name: 'Kevin Martin',
    role: 'Customers',
    text: 'To review means to look back over something for evaluation or memory. It’s always a joy to hear that the work I do has positively impacted our clients.'
  }
];

const Testimonials = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1
  };

  return (
    <section className="testimonial-section-two">
      <div className="bg-layer"></div>
      <div className="auto-container">
        <div className="sec-title text-center">
          <span className="sub-title">Yorumlarımız</span>
          <h2>
            What Our Customers are <br /> Talking About us.
          </h2>
        </div>

        <div className="carousel-outer">
          <Slider {...settings} className="testimonial-carousel-two">
            {testimonialData.map((item, index) => (
              <div className="testimonial-block-two" key={index}>
                <div className="inner-box">
                  <div className="image-box">
                    <figure className="image">
                      <img src={item.image} alt={item.name} />
                    </figure>
                  </div>
                  <div className="content-box">
                    <div className="rating">
                      {[...Array(5)].map((_, i) => (
                        <i className="fa fa-star" key={i}></i>
                      ))}
                    </div>
                    <div className="text">{item.text}</div>
                    <div className="info-box">
                      <h5 className="name">{item.name}</h5>
                      <span className="designation">{item.role}</span>
                      <span className="icon icon-quote-2"></span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;